import React from 'react';

import { FormContainer, FormAlert } from '@klp/formgenerator';
import type { Aktivitet } from '@klp/formgenerator/interfaces';

import { useCurrentUser } from '@klp/auth';
import type { ProjectTypeStatus } from '../../interfaces';
import { useFormattedDate } from '@klp/contractregistration/utils';
import { Typography } from '@klp/design/Typography';
import { useAssignResponsibleUser } from '../TildelAnsvarlig/hooks/useAssignResponsibleUser';
import { useFormAuth } from '@klp/formgenerator/hooks';

type ProsjektFormProps = {
    prosessInstansId: string;
    prosjektId: string;
    activity: Aktivitet;
    prosjektTypeStatus: ProjectTypeStatus;
};

export const ProsjektForm: React.FC<ProsjektFormProps> = ({
    prosessInstansId,
    prosjektId,
    activity,
    prosjektTypeStatus,
}) => {
    const { currentUser } = useCurrentUser();
    const formattedActivityDate = useFormattedDate(activity.utfortDato);
    const { isActivityEditable } = useFormAuth();
    const { handleAssignResponsibleUser, assigningTask } =
        useAssignResponsibleUser(prosjektId, prosessInstansId);

    const isDisabled = !isActivityEditable(activity);

    return (
        <>
            <FormAlert
                activity={activity}
                currentUser={currentUser}
                handleAssignResponsibleUser={(email) =>
                    handleAssignResponsibleUser(email, undefined, undefined)
                }
                assigningTask={assigningTask}
                registreringStatus={prosjektTypeStatus?.prosjektStatus}
            />

            <FormContainer
                prosessInstansId={prosessInstansId}
                prosjektId={prosjektId}
                activity={activity}
                formFields={activity.formFields}
                prosjektTypeStatus={prosjektTypeStatus}
                isDisabled={isDisabled}
            />

            {activity.utfortDato && (
                <Typography
                    paddingTop="compact"
                    translation="project.completedBy"
                    translationOptions={{
                        name: activity.tildeltTil,
                        date: formattedActivityDate,
                    }}
                />
            )}
        </>
    );
};
